import { getMethod, postMethod, putMethod } from "../../api-service/api-service";
import {
    setFilters,
    addFilterGroup,
    updateFilterGroup,
    removeFilterGroup,
    addFilter,
    updateFilter,
    removeFilter,
    setIsLoading,
    setError
} from "./filterSlice";

export const updateFilterGroupAction = (id, data) => async (dispatch) => {
    try {
        const response = await putMethod(`/filter-group/${id}`, data);
        if (response.success === true) {
            dispatch(updateFilterGroup(response?.filterGroup));
        };
        return response;
    } catch (error) {
        console.log("ERror: ", error);
        return { success: false, message: error };
    }
}

// export const fetchFilterGroupsAction = () => async (dispatch) => {
//     try {
//         const response = await getMethod('/filter-group');
//         if (response.success === true) {
//             dispatch(setFilterGroups(response?.filterGroups));
//         };
//         return response;
//     } catch (error) {
//         console.log("Error: ", error);
//         return { success: false, message: error };
//     }
// }

/* FETCH ALL FILTER GROUPS WITH FILTERS */
export const fetchAllFilters = () => async (dispatch) => {
    try {
        dispatch(setIsLoading(true));
        const res = await getMethod("/filter-group/fetch-all");
        if (res.success) dispatch(setFilters(res.filterGroups));
        dispatch(setIsLoading(false));
    } catch (error) {
        console.log(error);
        dispatch(setError(error.message));
        dispatch(setIsLoading(false));
    }
};

/* ADD FILTER GROUP */
export const addFilterGroupAction = (data) => async (dispatch) => {
    try {
        const res = await postMethod("/filter-group", data);
        if (res.success) dispatch(addFilterGroup(res.filterGroup));
        return res;
    } catch (error) {
        console.log(error);
        return { success: false, message: error.message };
    }
};

/* ADD FILTER */
export const addFilterAction = (filterGroupId, data) => async (dispatch) => {
    try {
        const res = await postMethod("/filter", { ...data, filterGroupId });
        if (res.success) dispatch(addFilter({
            filterGroupId, filter: {
                _id: res.filter._id,
                name: res.filter.name,
                imageUrl: res.filter.image?.url || ""
            }
        }));
        return res;
    } catch (error) {
        console.log(error);
        return { success: false, message: error.message };
    }
};